<div class="seneca-list-container">

    <!-- Success Message -->
    <mat-card *ngIf="isSubmitted" class="main-container">
      <mat-card-content style="padding: 40px 20px; text-align: center;">
        <mat-icon style="font-size: 56px; height: 56px; width: 56px; color: #4caf50;">check_circle</mat-icon>
        <h2 style="margin-top: 16px; color: #2e7d32;">Direct Deposit Information Submitted</h2>
        <p style="color: #555; font-size: 16px; max-width: 480px; margin: 12px auto 0;">
          Thank you! Your direct deposit details have been received. Our team will review your information and follow up if anything is needed.
        </p>
      </mat-card-content>
    </mat-card>

    <mat-card *ngIf="!isSubmitted" class="main-container">
      <mat-card-content class="main-content">
        <form
          [formGroup]="DDForm"
          class="form-container"
          (ngSubmit)="onSubmit()"
        >
          <h2><strong>Direct Deposit Information </strong></h2>
          <mat-card class="main-container">
            <mat-card-content>
              <table>
                <tr>
                  <th></th>
                  <th></th>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Payment Method</mat-label>
                      <input
                        matInput
                        [value]="paymentMethod === 'D' ? 'Direct Deposit' : 'Wire Transfer'"
                        readonly
                      />
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Company Legal Name</mat-label>
                      <input
                        matInput
                        formControlName="DD_Legal_Name"
                        type="text"
                        maxlength="100"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="DDForm.get('DD_Legal_Name')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="DDForm.get('DD_Legal_Name')?.hasError('pattern')"> Cannot be blank</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
                <tr>
                   <td>
                    <mat-form-field appearance="outline">
                      <mat-label>HST/ GST Number</mat-label>
                      <input
                        matInput
                        formControlName="DD_HST_GST_Number"
                        type="text"
                        maxlength="30"
                      />
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Social Insurance Number</mat-label>
                      <input
                        matInput
                        formControlName="DD_SIN"
                        type="text"
                        maxlength="11"
                      />
                    </mat-form-field>
                  </td>
                </tr>
              </table>
            </mat-card-content>
          </mat-card>

          <br />
          <h2><strong>Main Contact Person</strong></h2>
          <mat-card class="main-container">
            <mat-card-content>
              <table>
                <tr>
                  <th></th>
                  <th></th>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Last Name</mat-label>
                      <input
                        matInput
                        formControlName="CP_Last_Name"
                        type="text"
                        maxlength="50"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="DDForm.get('CP_Last_Name')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="DDForm.get('CP_Last_Name')?.hasError('pattern')"> Invalid last name</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>First Name</mat-label>
                      <input
                        matInput
                        formControlName="CP_First_Name"
                        type="text"
                        maxlength="50"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="DDForm.get('CP_First_Name')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="DDForm.get('CP_First_Name')?.hasError('pattern')"> Invalid first name</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Telephone</mat-label>
                      <input
                        matInput
                        formControlName="CP_Bank_Phone"
                        type="tel"
                        maxlength="20"
                      />
                      <mat-hint>Include area code</mat-hint>
                      <mat-error>
                        <em class="error-hint" *ngIf="DDForm.get('CP_Bank_Phone')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="DDForm.get('CP_Bank_Phone')?.hasError('pattern')"> Enter a valid phone number</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Email</mat-label>
                      <input
                        matInput
                        formControlName="CP_Email"
                        type="email"
                        maxlength="150"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="DDForm.get('CP_Email')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="DDForm.get('CP_Email')?.hasError('email')"> Invalid email</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
              </table>
            </mat-card-content>
          </mat-card>

          <br />
          <h2><strong>Name of Authorized Signatory </strong></h2>
          <mat-card class="main-container">
            <mat-card-content>
              <table>
                <tr>
                  <th></th>
                  <th></th>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Last Name</mat-label>
                      <input
                        matInput
                        formControlName="AS_Last_Name"
                        type="text"
                        maxlength="50"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="DDForm.get('AS_Last_Name')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="DDForm.get('AS_Last_Name')?.hasError('pattern')"> Invalid last name</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>First Name</mat-label>
                      <input
                        matInput
                        formControlName="AS_First_Name"
                        type="text"
                        maxlength="50"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="DDForm.get('AS_First_Name')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="DDForm.get('AS_First_Name')?.hasError('pattern')"> Invalid first name</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Title</mat-label>
                      <input
                        matInput
                        formControlName="AS_Title"
                        type="text"
                        maxlength="10"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="DDForm.get('AS_Title')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="DDForm.get('AS_Title')?.hasError('pattern')"> Cannot be blank</em>
                        <em class="error-hint" *ngIf="DDForm.get('AS_Title')?.hasError('maxlength')"> Max 10 characters</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Address</mat-label>
                      <input
                        matInput
                        formControlName="AS_Address"
                        type="text"
                        maxlength="200"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="DDForm.get('AS_Address')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="DDForm.get('AS_Address')?.hasError('pattern')"> Cannot be blank</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Telephone</mat-label>
                      <input
                        matInput
                        formControlName="AS_Phone"
                        type="tel"
                        maxlength="20"
                      />
                      <mat-hint>Include area code</mat-hint>
                      <mat-error>
                        <em class="error-hint" *ngIf="DDForm.get('AS_Phone')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="DDForm.get('AS_Phone')?.hasError('pattern')"> Enter a valid phone number</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
              </table>
            </mat-card-content>
          </mat-card>

          <br />
          <h2><strong>Beneficiary Bank </strong></h2>
          <mat-card class="main-container">
            <mat-card-content>
              <table>
                <tr>
                  <th></th>
                  <th></th>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Bank Name</mat-label>
                      <input
                        matInput
                        formControlName="BF_Bank_Name"
                        type="text"
                        maxlength="250"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="DDForm.get('BF_Bank_Name')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="DDForm.get('BF_Bank_Name')?.hasError('pattern')"> Cannot be blank</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Bank Address</mat-label>
                      <input
                        matInput
                        formControlName="BF_Bank_Address"
                        type="text"
                        maxlength="200"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="DDForm.get('BF_Bank_Address')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="DDForm.get('BF_Bank_Address')?.hasError('pattern')"> Cannot be blank</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Telephone</mat-label>
                      <input
                        matInput
                        formControlName="BF_Bank_Phone"
                        type="tel"
                        maxlength="20"
                      />
                      <mat-hint>Include area code</mat-hint>
                      <mat-error>
                        <em class="error-hint" *ngIf="DDForm.get('BF_Bank_Phone')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="DDForm.get('BF_Bank_Phone')?.hasError('pattern')"> Enter a valid phone number</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Bank Code</mat-label>
                      <input
                        matInput
                        formControlName="BF_Bank_Code"
                        type="text"
                        maxlength="25"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="DDForm.get('BF_Bank_Code')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="DDForm.get('BF_Bank_Code')?.hasError('pattern')"> Invalid bank code</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
                <tr>
                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Account Number</mat-label>
                      <input
                        matInput
                        formControlName="BF_Bank_Account"
                        type="text"
                        maxlength="25"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="DDForm.get('BF_Bank_Account')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="DDForm.get('BF_Bank_Account')?.hasError('pattern')"> Invalid account number</em>
                      </mat-error>
                    </mat-form-field>
                  </td>

                  <td>
                    <mat-form-field appearance="outline">
                      <mat-label>Transit Number</mat-label>
                      <input
                        matInput
                        formControlName="BF_Bank_Transit"
                        type="text"
                        maxlength="25"
                      />
                      <mat-error>
                        <em class="error-hint" *ngIf="DDForm.get('BF_Bank_Transit')?.hasError('required')"> Required</em>
                        <em class="error-hint" *ngIf="DDForm.get('BF_Bank_Transit')?.hasError('pattern')"> Invalid transit number</em>
                      </mat-error>
                    </mat-form-field>
                  </td>
                </tr>
              </table>
            </mat-card-content>
          </mat-card>
          <div class="actions-box">
            <mat-card-actions>
              <button
                mat-stroked-button
                type="button"
                class="seneca-button red"
                color="primary"
                (click)="goToAgencyList()"
              >
                <span>Cancel</span>
              </button>
              &nbsp;
              <button
                *ngIf="showFillTestDataButton"
                mat-stroked-button
                type="button"
                class="seneca-button"
                color="primary"
                (click)="fillTestData()"
              >
                <span>Fill Test Data</span>
              </button>
              &nbsp;
              <button
                type="submit"
                mat-flat-button
                class="seneca-button"
                color="primary"
                [disabled]="DDForm.invalid || isSubmitting"
              >
                <span>{{ isSubmitting ? 'Submitting...' : 'Submit' }}</span>
              </button>
            </mat-card-actions>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
